import React, { memo, forwardRef } from 'react';
import { makeStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Trackable } from '@dpdgroupuk/react-event-tracker';
import { Typography } from '@mui/material';

import layout from '../styles/layout';
import palette from '../styles/palette';
import { View } from '../Base';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    height: layout.rightDrawerModal.toolbarHeight,
    backgroundColor: palette.typography.white.solid,
    color: palette.typography.black.high,
    borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
    boxShadow: 'none',
    fontSize: theme.typography.pxToRem(20),
  },
  toolbar: {
    minHeight: layout.rightDrawerModal.toolbarHeight,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    textTransform: 'uppercase',
  },
  container: {
    position: 'relative',
    top: layout.rightDrawerModal.topSpace,
    height: `calc(100% - ${layout.rightDrawerModal.topSpace}px)`,
    left: layout.rightDrawerModal.leftSpace,
    width: `calc(100% - ${layout.rightDrawerModal.leftSpace}px)`,
  },
  containerPaper: {
    backgroundColor: palette.modalBackground,
  },
  content: {
    flex: 1,
    overflow: 'auto',
  },
}));

// eslint-disable-next-line react/display-name
const Transition = forwardRef((props, ref) => (
  <Slide direction="left" ref={ref} {...props} />
));

const RightDrawerModal = ({
  open,
  onClose,
  title,
  actions,
  children,
  DialogProps = {},
  loadId,
}) => {
  const classes = useStyles();

  return (
    <Trackable loadId={loadId} modal>
      <Dialog
        {...DialogProps}
        fullScreen
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
        classes={{
          container: classes.container,
          paper: classes.containerPaper,
        }}
      >
        <AppBar className={classes.appBar}>
          <Toolbar variant="dense" className={classes.toolbar}>
            <IconButton
              data-testid="close-icon"
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>

            {actions}
          </Toolbar>
        </AppBar>
        <View className={classes.content}>{children}</View>
      </Dialog>
    </Trackable>
  );
};

export default memo(RightDrawerModal);
